// frontend/src/brand.js
export const BRAND = {
  name: "Ђачка задруга",
  tagline: "Ауто школа • Технички преглед • Хомологација",
  phone: "068 331 353",
  place: "Пљевља",

  colors: {
    red: "#c62828",
    blue: "#1976d2",
    bg: "#f4f6f9",
    text: "#1f2937",
    card: "#ffffff",
    border: "#e5e7eb",
  },
};